module.exports = __webpack_public_path__ + "static/media/video-placeholder.baf57f23.png";